<template>
    <div :class="['row',...this.clazz]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "vRow",
        props:{
            clazz:{
                default:function () {
                    return []
                },
                type:Array
            }
        }
    }
</script>

<style scoped>

</style>